import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { SupplierListQuery } from '@/api/handlers/resources/suppliers/requests';
import type { GetSupplierDetailsResponse } from '@/api/handlers/resources/suppliers/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { SupplierQueryKeys } from './supplierQueryKeys';

/**
 * Reads `GET /suppliers/details` (server-paginated, BOS-81) for the management
 * table. Consumers that need the whole supplier set (dropdowns, import
 * name-matching) use {@link useSupplierPickerQuery} instead.
 */
export const useSupplierDetailsQuery = (
    query: SupplierListQuery,
    enabled = true,
) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetSupplierDetailsResponse>>({
        queryKey: SupplierQueryKeys.detailsPage(query),
        queryFn: () => apiClient.suppliers.getSupplierDetails(query),
        enabled,
        staleTime: 60_000,
        // Keep the current page on screen while the next one loads so paging
        // doesn't flash the skeleton.
        placeholderData: keepPreviousData,
    });
};
